import { SET_LEASES, SET_LEASE } from './mutations';

const setLeases = ({ commit }, payload) => commit(SET_LEASES, payload);
const setLease = ({ commit }, payload) => commit(SET_LEASE, payload);

export default {
    setLeases,
    setLease,
};
